import React from "react";

const Books = ({ checkboxState, handleCheckboxChange }) => {
  return (
    <div>
      <div className="edit-profile-interest-option-div">
        <div className="edit-profile-icon-wrapper intminheight">
          <div className="tabs-nav-icon w-embed">
            <svg
              width="100%"
              height="100%"
              viewBox="0 0 83 78"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_24_775)">
                <path
                  d="M67.7593 32.6306C65.6689 32.5202 63.6394 32.156 61.7205 31.2949C57.9988 29.6281 55.7149 26.4489 54.2052 22.8171C51.7831 22.8889 49.5821 24.0204 47.2097 24.4178C44.6162 24.8538 42.2493 24.3957 40.0373 22.9662C39.5949 22.6792 39.2797 22.3259 39.0696 21.9451H30.4649C26.8151 21.9451 23.8288 24.9256 23.8288 28.5684V47.6047C23.8288 51.2475 26.8151 54.228 30.4649 54.228H63.0975C66.7473 54.228 69.7335 51.2475 69.7335 47.6047V32.7686C69.0588 32.7245 68.3952 32.6637 67.7648 32.6306H67.7593Z"
                  fill="#E2B760"
                />
                <path
                  d="M63.1804 55.376H27.9542C23.7293 55.376 20.2896 51.943 20.2896 47.7262V26.2888C20.2896 22.072 23.7293 18.639 27.9542 18.639H31.2888C31.7478 18.639 32.1183 19.0088 32.1183 19.4669C32.1183 19.925 31.7478 20.2948 31.2888 20.2948H27.9542C24.6417 20.2948 21.9486 22.9827 21.9486 26.2888V47.7262C21.9486 51.0323 24.6417 53.7202 27.9542 53.7202H63.1804C66.4929 53.7202 69.186 51.0323 69.186 47.7262V36.5935C69.186 36.1354 69.5565 35.7656 70.0155 35.7656C70.4745 35.7656 70.845 36.1354 70.845 36.5935V47.7262C70.845 51.943 67.4054 55.376 63.1804 55.376Z"
                  fill="#000"
                />
                <path
                  d="M63.1804 49.1226H47.3259C46.8669 49.1226 46.4964 48.7528 46.4964 48.2946C46.4964 47.8365 46.8669 47.4667 47.3259 47.4667H62.9205V44.2213C62.9205 43.7632 63.291 43.3934 63.75 43.3934C64.209 43.3934 64.5795 43.7632 64.5795 44.2213V47.7262C64.5795 48.4823 63.938 49.1226 63.1804 49.1226Z"
                  fill="#000"
                />
                <path
                  d="M3.63322 47.2073C3.06916 47.2073 2.5051 47.0749 1.98528 46.8099C0.763142 46.1862 0 44.9499 0 43.5811V30.4394C0 29.0706 0.757612 27.8343 1.98528 27.2106C3.20741 26.5869 4.65627 26.7028 5.76781 27.5086L14.8204 34.0767C15.7716 34.7666 16.3135 35.8319 16.3135 37.0075C16.3135 38.1831 15.7661 39.2484 14.8204 39.9383L5.76781 46.5119C5.13185 46.9755 4.3853 47.2073 3.63322 47.2073ZM3.63875 28.4635C3.3346 28.4635 3.02492 28.5352 2.73736 28.6843C2.0627 29.0265 1.659 29.6833 1.659 30.4394V43.5811C1.659 44.3372 2.0627 44.9941 2.73736 45.3363C3.41202 45.6785 4.18069 45.6177 4.78899 45.1762L13.8416 38.6026C14.3559 38.2273 14.6545 37.6477 14.6545 37.013C14.6545 36.3783 14.3559 35.7988 13.8416 35.4234L4.78899 28.8498C4.4406 28.596 4.04244 28.469 3.63322 28.469L3.63875 28.4635Z"
                  fill="#000"
                />
                <path
                  d="M30.1939 78C29.757 78 29.3201 77.8951 28.9165 77.6909C27.9874 77.2107 27.4123 76.2724 27.4123 75.2403C27.4123 75.152 27.4178 75.0692 27.4234 74.9864C27.5727 73.5072 28.0095 72.1384 28.734 70.8965L35.1598 59.8247C35.3921 59.4273 35.9009 59.2948 36.2935 59.5211C36.6917 59.7474 36.8244 60.2552 36.5976 60.6526L30.1718 71.7245C29.569 72.7621 29.1985 73.9046 29.0768 75.1189C29.0768 75.163 29.0713 75.1961 29.0713 75.2348C29.0713 75.6543 29.298 76.0185 29.6796 76.2172C29.8621 76.3111 30.3377 76.4932 30.8409 76.1344C31.8252 75.439 32.6382 74.5559 33.252 73.5017L41.1931 59.8247C41.4254 59.4273 41.9341 59.2948 42.3267 59.5211C42.7249 59.7474 42.8576 60.2552 42.6309 60.6526L34.6898 74.3351C33.9543 75.5991 32.981 76.6588 31.8031 77.4922C31.322 77.8289 30.7635 78.0055 30.1994 78.0055L30.1939 78Z"
                  fill="#000"
                />
                <path
                  d="M60.9408 78C60.3767 78 59.8182 77.8289 59.3371 77.4867C58.1647 76.6588 57.1693 75.5659 56.4559 74.3296L48.5148 60.6526C48.2826 60.2552 48.4208 59.7529 48.819 59.5211C49.2116 59.2948 49.7204 59.4273 49.9526 59.8247L57.8937 73.5072C58.491 74.5393 59.3205 75.45 60.2993 76.14C60.8025 76.4932 61.2781 76.3166 61.4606 76.2228C61.8422 76.0241 62.0689 75.6598 62.0689 75.2403C62.0689 75.2017 62.0689 75.1686 62.0634 75.1354C61.9472 73.9377 61.5712 72.7621 60.974 71.7245L54.5481 60.6526C54.3158 60.2552 54.4541 59.7529 54.8522 59.5211C55.2504 59.2948 55.7536 59.4273 55.9859 59.8247L62.4118 70.8965C63.1307 72.1384 63.5841 73.5459 63.7168 74.9643C63.7279 75.0858 63.7334 75.1575 63.7334 75.2403C63.7334 76.2724 63.1583 77.2107 62.2293 77.6909C61.8256 77.9006 61.3887 78 60.9518 78H60.9408Z"
                  fill="#000"
                />
                <path
                  d="M45.8051 23.2421C39.3848 23.2421 34.1644 18.0318 34.1644 11.6238C34.1644 5.21582 39.3848 0 45.8051 0C49.372 0 52.69 1.60062 54.9075 4.38239C55.1896 4.74115 55.1343 5.25998 54.7748 5.54699C54.4153 5.82847 53.8955 5.77328 53.608 5.41452C51.7056 3.02463 48.8632 1.65582 45.8051 1.65582C40.2972 1.65582 35.8234 6.12652 35.8234 11.6183C35.8234 17.1101 40.3027 21.5808 45.8051 21.5808C47.1378 21.5808 48.4263 21.3269 49.6319 20.8191C50.0522 20.6425 50.5388 20.8412 50.7158 21.2607C50.8927 21.6802 50.6936 22.1659 50.2734 22.3425C48.8632 22.9331 47.3646 23.2311 45.8051 23.2311V23.2421Z"
                  fill="#000"
                />
                <path
                  d="M68.6883 31.7806C60.797 31.7806 54.3766 25.3726 54.3766 17.4965C54.3766 9.62029 60.797 3.21228 68.6883 3.21228C76.5796 3.21228 83 9.62029 83 17.4965C83 25.3726 76.5796 31.7806 68.6883 31.7806ZM68.6883 4.8681C61.7094 4.8681 56.0356 10.531 56.0356 17.4965C56.0356 24.4619 61.7094 30.1248 68.6883 30.1248C75.6672 30.1248 81.341 24.4619 81.341 17.4965C81.341 10.531 75.6672 4.8681 68.6883 4.8681Z"
                  fill="#000"
                />
                <path
                  d="M68.6883 21.9506C66.2275 21.9506 64.2256 19.9526 64.2256 17.4965C64.2256 15.0403 66.2275 13.0423 68.6883 13.0423C71.1492 13.0423 73.151 15.0403 73.151 17.4965C73.151 19.9526 71.1492 21.9506 68.6883 21.9506ZM68.6883 14.6981C67.1454 14.6981 65.8846 15.951 65.8846 17.4965C65.8846 19.0419 67.1399 20.2948 68.6883 20.2948C70.2367 20.2948 71.492 19.0419 71.492 17.4965C71.492 15.951 70.2367 14.6981 68.6883 14.6981Z"
                  fill="#000"
                />
              </g>
              <defs>
                <clipPath id="clip0_24_775">
                  <rect width={83} height={78} fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
        <label className="w-checkbox ms-pill-item">
          <input
            type="checkbox"
            name="checkbox-3"
            id="checkbox-3w"
            data-name="Checkbox 3"
            className="w-checkbox-input ms-pill-checkbox"
            checked={checkboxState.Books}
            onChange={handleCheckboxChange("Books")}
          />
          <span
            className="ms-pill-label has-icon w-form-label"
            htmlFor="checkbox-3"
          >
            Books/Movies
          </span>
          <div className="ms-pill-icon w-embed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 0 24 24"
              width="24px"
              fill="currentColor"
            >
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" />
            </svg>
          </div>
        </label>
      </div>
    </div>
  );
};

export default Books;
